// extracted by mini-css-extract-plugin
export default {"wrap":"PI-z","fullWidth":"QI-z","hideOnDesktop":"RI-z","content":"SI-z","hasOpenedNav":"TI-z","crumbsList":"UI-z","dropdownsWrap":"VI-z"};